import * as actions from '../../utils/Actions';
import { notUndefinedAndNull } from '../../utils/Validation';

const initialState = {
    showPageLoader: false,
    paidFees: null,
    unpaidFees: [],
    feeInfo: null,
    displayLayouts: [],
    siDetails:[],
    siDetailsView:[],
    siDeleteStatus:null,
    upiDetails:[],
    revokeMessage:null,
    revokeStatus:null,
    initPayment: false,
    remarkSubmitted: false,
    redirectUrl: null,
    paymentStatus: null,
    receiptEmailed: false,
    additionalFees: [],
    additionalFeesApplied:false,
    otherAdditionalFeesDeleted: false,
    feesByRule : null,
    collectFeesDetails:null,
    saveUnregisteredUserResponse:null,
    appInfo:null,
    isCaptchaRejected: false,
    showDuesLoader:false,
    feeFinanceDetails:null,
    feeType:null

}

export default function payments(state = initialState, action) {

    if (typeof state === 'undefined') {
        return state;
    }

    switch (action.type) {

        case actions.RESET_PAYMENT_STATUS:
            return {
                ...state,
                initPayment: false,
                remarkSubmitted: false, 
                feeInfo: null,
                revokeMessage:null,
                revokeStatus:null,
                siDeleteStatus:null,
                paymentStatus:null,
                receiptEmailed: false,
                showDuesLoader:false,
                redirectUrl: null,
                isCaptchaRejected: false,
            }


        case actions.RESET_UNPAID_FEES:
            return {
                ...state,
                initPayment: false,
                remarkSubmitted: false, 
                feeInfo: null,
                revokeMessage:null,
                revokeStatus:null,
                siDeleteStatus:null,
                paymentStatus:null,
                receiptEmailed: false,
                showDuesLoader:false,
                redirectUrl: null,
                paidFees: null,
                isCaptchaRejected: false,
                unpaidFees:[]
            }


            
            
            
        case actions.RESET_PRINT_RECIEPT_DATA:
            return {
                ...state,
                printRecieptData: null
            }

        case actions.RESET_PAID_FEES_DATA:
            return {
                ...state,
                paidFees: null
            }

        case actions.APPLY_FIRST_TIME_ADDITIONAL_FEES:
            return{
                ...state,
                otherAdditionalFeesDeleted: true
            }

        case actions.pending(actions.GET_PAID_FEES_BY_QFIX_REFERENCE_NUMBER):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_PAID_FEES_BY_QFIX_REFERENCE_NUMBER):
            return {
                ...state,
                showPageLoader: false,
                paidFees: action.payload.data,
                isCaptchaRejected: false
            }

        case actions.rejected(actions.GET_PAID_FEES_BY_QFIX_REFERENCE_NUMBER):

            return {
                ...state,
                showPageLoader: false,
                isCaptchaRejected: true

            }

        case actions.pending(actions.GET_PAID_FEES_BY_PAYMENT_GATEWAY_TRANSACTION_ID):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_PAID_FEES_BY_PAYMENT_GATEWAY_TRANSACTION_ID):
            return {
                ...state,
                showPageLoader: false,
                paidFees: action.payload.data,
                isCaptchaRejected: false
            }

        case actions.rejected(actions.GET_PAID_FEES_BY_PAYMENT_GATEWAY_TRANSACTION_ID):

            return {
                ...state,
                showPageLoader: false,
                isCaptchaRejected: true

            }

        case actions.pending(actions.GET_UNPAID_FEES):
            return {
                ...state,
                showDuesLoader: true,
                unpaidFees:[]
            }

        case actions.fulfilled(actions.GET_UNPAID_FEES):
            return {
                ...state,
                showDuesLoader: false,
                unpaidFees: action.payload.data
            }

        case actions.rejected(actions.GET_UNPAID_FEES):
            return {
                ...state,
                showDuesLoader: false
            }

        case actions.pending(actions.GET_FEE_INFO):
            return {
                ...state,
                showPageLoader: true,
                feeInfo: null
            }

        case actions.fulfilled(actions.GET_FEE_INFO):
            let feeInfo = action.payload.data;
            feeInfo['dueObject'] = action.meta.due;
            return {
                ...state,
                showPageLoader: false,
                feeInfo: feeInfo
            }

        case actions.rejected(actions.GET_FEE_INFO):
            return {
                ...state,
                showPageLoader: false,
                feeInfo: null
            }

        case actions.pending(actions.GET_PRINT_RECIEPT_DATA):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_PRINT_RECIEPT_DATA):
            return {
                ...state,
                showPageLoader: false,
                printRecieptData: action.payload.data
            }

        case actions.rejected(actions.GET_PRINT_RECIEPT_DATA):
            return {
                ...state,
                showPageLoader: false,
            }

        case actions.pending(actions.GET_FEES_BREAKUP):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_FEES_BREAKUP):
            return {
                ...state,
                showPageLoader: false,
                displayLayouts: action.payload.data
            }

        case actions.rejected(actions.GET_FEES_BREAKUP):
            return {
                ...state,
                showPageLoader: false,
            }

        case actions.pending(actions.GET_STANDING_INSTRUCTION):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_STANDING_INSTRUCTION):
            let siData = action.payload.data
            let siDetails = (notUndefinedAndNull(siData) && siData.length > 0 ) ?  siData : null;
            return {
                ...state,
                showPageLoader: false,
                siDetails: siDetails
            }

        case actions.rejected(actions.GET_STANDING_INSTRUCTION):
            return {
                ...state,
                showPageLoader: false,
            }

        case actions.pending(actions.GET_STANDING_INSTRUCTION_VIEW):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_STANDING_INSTRUCTION_VIEW):
            let siDataView = action.payload.data
            let siDetailsView = (notUndefinedAndNull(siDataView) && siDataView.length > 0 ) ?  siDataView : null;
            return {
                ...state,
                showPageLoader: false,
                siDetailsView: siDetailsView
            }

        case actions.rejected(actions.GET_STANDING_INSTRUCTION_VIEW):
            return {
                ...state,
                showPageLoader: false,
            }

        case actions.pending(actions.GET_UPI_MANDATE):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_UPI_MANDATE):
            let upiData = action.payload.data
            let upiDetails = (notUndefinedAndNull(upiData) && upiData.length > 0 ) ?  upiData : null;
            return {
                ...state,
                showPageLoader: false,
                upiDetails: upiDetails
            }

        case actions.rejected(actions.GET_UPI_MANDATE):
            return {
                ...state,
                showPageLoader: false,
            }

        case actions.pending(actions.REVOKE_UPI_MANDATE):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.REVOKE_UPI_MANDATE):
            let revokeMessage = action.payload.data.message
            let revokeStatus = action.payload.data.status
            return {
                ...state,
                showPageLoader: false,
                revokeMessage: revokeMessage,
                revokeStatus: revokeStatus
            }

        case actions.rejected(actions.REVOKE_UPI_MANDATE):
            return {
                ...state,
                showPageLoader: false,
            }

        case actions.pending(actions.SUBMIT_DUES_REMARKS):
            return {
                ...state,
                showPageLoader: true,
                initPayment: false,

            }

        case actions.fulfilled(actions.SUBMIT_DUES_REMARKS):
            
            return {
                ...state,
                showPageLoader: false,
                initPayment: true,
                remarkSubmitted: true
            }

        case actions.rejected(actions.SUBMIT_DUES_REMARKS):
            return {
                ...state,
                showPageLoader: false,
            }
        case actions.pending(actions.INIT_PAYMENT):
            return {
                ...state,
                showPageLoader: true,
                redirectUrl: null

            }

        case actions.fulfilled(actions.INIT_PAYMENT):
            
            return {
                ...state,
                showPageLoader: false,
                redirectUrl: action.payload.data.redirect_url

            }

        case actions.rejected(actions.INIT_PAYMENT):
            return {
                ...state,
                showPageLoader:false,
                redirectUrl: null
            }    

        case actions.pending(actions.EMAIL_RECEIPT):
            return {
                ...state,
                showPageLoader: true,
                receiptEmailed: false

            }

        case actions.fulfilled(actions.EMAIL_RECEIPT):
            
            return {
                ...state,
                showPageLoader: false,
                receiptEmailed: true

            }

        case actions.rejected(actions.EMAIL_RECEIPT):
            return {
                ...state,
                showPageLoader:false
            }

        case actions.pending(actions.GET_PAYMENT_STATUS):
            return {
                ...state,
                showPageLoader: true,
                paymentStatus: null

            }

        case actions.fulfilled(actions.GET_PAYMENT_STATUS):
            
            return {
                ...state,
                showPageLoader: false,
                paymentStatus: action.payload.data

            }

        case actions.rejected(actions.GET_PAYMENT_STATUS):
            return {
                ...state,
                showPageLoader: false,
                paymentStatus: null
            } 

        case actions.pending(actions.GET_ADDITIONAL_FEES):
            return {
                ...state,
                showPageLoader: true,

            }

        case actions.fulfilled(actions.GET_ADDITIONAL_FEES):
                return {
                    ...state,
                    showPageLoader: false,
                    additionalFees: action.payload.data
                }
    
        case actions.rejected(actions.GET_ADDITIONAL_FEES):
                return {
                    ...state,
                    showPageLoader: false,
                    additionalFees: []
                }  

        case actions.pending(actions.APPLY_ADDITIONAL_FEES):
           
                return {
                    ...state,
                    showPageLoader: true,

                }

        case actions.fulfilled(actions.APPLY_ADDITIONAL_FEES):
                return {
                    ...state,
                    showPageLoader: false,
                    additionalFeesApplied: true
                }
    
        case actions.rejected(actions.APPLY_ADDITIONAL_FEES):
                return {
                    ...state,
                    showPageLoader: false,
                }  


        case actions.pending(actions.DELETE_ADDITIONAL_FEES):

                return {
                    ...state,
                    showPageLoader: true,
                    otherAdditionalFeesDeleted: false,
                    additionalFeesApplied: false
                }

        case actions.fulfilled(actions.DELETE_ADDITIONAL_FEES):
                return {
                    ...state,
                    showPageLoader: false,
                    otherAdditionalFeesDeleted: true,
                    additionalFeesApplied: false
                }
    
        case actions.rejected(actions.DELETE_ADDITIONAL_FEES):
                return {
                    ...state,
                    showPageLoader: false,
                    otherAdditionalFeesDeleted: false,
                    additionalFeesApplied: false
                }

        case actions.pending(actions.SEARCH_FEES_BY_RULE):

                return {
                    ...state,
                    showPageLoader: true
                }

        case actions.fulfilled(actions.SEARCH_FEES_BY_RULE):
                return {
                    ...state,
                    showPageLoader: false,
                    feesByRule: action.payload.data,
                    unpaidFees : action.payload.data.dues
                }
    
        case actions.rejected(actions.SEARCH_FEES_BY_RULE):
                return {
                    ...state,
                    showPageLoader: false
                }

        case actions.pending(actions.GET_COLLECT_FEES_DETAILS):

                return {
                    ...state,
                    showPageLoader: true
                }

        case actions.fulfilled(actions.GET_COLLECT_FEES_DETAILS):
                return {
                    ...state,
                    showPageLoader: false,
                    collectFeesDetails: action.payload.data,
                }
    
        case actions.rejected(actions.GET_COLLECT_FEES_DETAILS):
                return {
                    ...state,
                    showPageLoader: false
                }

        case actions.pending(actions.SAVE_UNREGISTERED_USER):

                return {
                    ...state,
                    showPageLoader: true
                }

        case actions.fulfilled(actions.SAVE_UNREGISTERED_USER):
                return {
                    ...state,
                    showPageLoader: false,
                    saveUnregisteredUserResponse: action.payload.data,
                }
    
        case actions.rejected(actions.SAVE_UNREGISTERED_USER):
                return {
                    ...state,
                    showPageLoader: false
                }

        case actions.pending(actions.GET_APP_INFO):

                return {
                    ...state,
                    showPageLoader: true
                }

        case actions.fulfilled(actions.GET_APP_INFO):
                return {
                    ...state,
                    showPageLoader: false,
                    appInfo: action.payload.data
                }
    
        case actions.rejected(actions.GET_APP_INFO):
                return {
                    ...state,
                    showPageLoader: false
                }


        case actions.pending(actions.GET_FEE_FINANCE):
            return {
                ...state, 
            showPageLoader:true
        }

        case actions.fulfilled(actions.GET_FEE_FINANCE):
            return {
                ...state,
                showPageLoader: false,
                feeFinanceDetails: action.payload.data
            }    

        case actions.rejected(actions.GET_FEE_FINANCE):
            return {
                ...state,
                showPageLoader: false,
            }

        case actions.pending(actions.GET_FEE_TYPE):
            return {
                ...state, 
            showPageLoader:true,
            feeType:null
        }

        case actions.fulfilled(actions.GET_FEE_TYPE):
            return {
                ...state,
                showPageLoader: false,
                feeType: action.payload.data
            }    

        case actions.rejected(actions.GET_FEE_TYPE):
            return {
                ...state,
                showPageLoader: false,
            }
                
        default:
            return { ...state }

    }
} 
